import i18n from '@/plugins/i18n';
import * as moment from 'moment';
import { String } from 'typescript-string-operations';
import { UserActionEntityType } from './user-action-entity-type';
import { UserActionScopeType } from './user-action-scope-type';
import { UserActionType } from './user-action-type';

export class UserActionLogInfo {
    public id: number = 0;
    public dateUtc!: moment.Moment;
    public userId: number = 0;
    public userEmail: string = '';
    public type: UserActionType = UserActionType.HasLoggedIn;
    public entity?: UserActionEntityType;
    public scope?: UserActionScopeType;
    public entityId?: number;
    public applicationCommercialName: string = '';

    public get dateLocal(): string {
        return moment.utc(this.dateUtc).local().format('DD/MM/YYYY HH:mm');
    }

    public get action(): string {
        const result = String.Format(i18n.t('common.userActions.summaryHtml').toString(), this.getUserActionType(), this.getUserActionScopeType(), this.getUserActionEntityType(), this.entityId ? String.Format('<i>{0}</i>', this.entityId) : '');
        return result;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    private getUserActionType(): string {
        switch (this.type) {
            case UserActionType.HasLoggedIn:
                return i18n.t('common.userActions.actions.hasLoggedIn').toString();
            case UserActionType.HasVisited:
                return i18n.t('common.userActions.actions.hasVisited').toString();
            case UserActionType.HasCreated:
                return i18n.t('common.userActions.actions.hasCreated').toString();
            case UserActionType.HasChanged:
                return i18n.t('common.userActions.actions.hasChanged').toString();
            case UserActionType.HasDeleted:
                return i18n.t('common.userActions.actions.hasDeleted').toString();
            case UserActionType.HasCloned:
                return i18n.t('common.userActions.actions.hasCloned').toString();
        }
    }

    private getUserActionScopeType(): string {
        switch (this.scope) {
            case UserActionScopeType.New:
                return i18n.t('common.userActions.actionScope.new').toString();
            case UserActionScopeType.Delete:
                return i18n.t('common.userActions.actionScope.delete').toString();
            case UserActionScopeType.Edit:
                return i18n.t('common.userActions.actionScope.edit').toString();
            case UserActionScopeType.Details:
                return i18n.t('common.userActions.actionScope.details').toString();
            case UserActionScopeType.List:
                return i18n.t('common.userActions.actionScope.list').toString();
            case UserActionScopeType.Dashboard:
                return i18n.t('common.userActions.actionScope.dashboard').toString();
            case UserActionScopeType.Frontpage:
                return i18n.t('common.userActions.actionScope.frontpage').toString();
            case UserActionScopeType.Owner:
                return i18n.t('common.userActions.actionScope.owner').toString();
            case UserActionScopeType.Logo:
                return i18n.t('common.userActions.actionScope.logo').toString();
            case UserActionScopeType.BasicData:
                return i18n.t('common.userActions.actionScope.basicData').toString();
            case UserActionScopeType.ProjectData:
                return i18n.t('common.userActions.actionScope.projectData').toString();
            case UserActionScopeType.ContactData:
                return i18n.t('common.userActions.actionScope.contactData').toString();
            case UserActionScopeType.Description:
                return i18n.t('common.userActions.actionScope.description').toString();
            case UserActionScopeType.Slug:
                return i18n.t('common.userActions.actionScope.slug').toString();
            case UserActionScopeType.Publication:
                return i18n.t('common.userActions.actionScope.publication').toString();
            case UserActionScopeType.Availability:
                return i18n.t('common.userActions.actionScope.availability').toString();
            case UserActionScopeType.Titles:
                return i18n.t('common.userActions.actionScope.titles').toString();
            case UserActionScopeType.Images:
                return i18n.t('common.userActions.actionScope.images').toString();
            case UserActionScopeType.OtherLinks:
                return i18n.t('common.userActions.actionScope.otherLinks').toString();
            case UserActionScopeType.SocialMediaLinks:
                return i18n.t('common.userActions.actionScope.socialMediaLinks').toString();
            case UserActionScopeType.BillingData:
                return i18n.t('common.userActions.actionScope.billingData').toString();
            case UserActionScopeType.Logistics:
                return i18n.t('common.userActions.actionScope.logistics').toString();
            case UserActionScopeType.PickupAddress:
                return i18n.t('common.userActions.actionScope.pickupAddress').toString();
            case UserActionScopeType.PickupDelivery:
                return i18n.t('common.userActions.actionScope.pickupDelivery').toString();
            case UserActionScopeType.ShippingRate:
                return i18n.t('common.userActions.actionScope.shippingRate').toString();
            case UserActionScopeType.ShippingRateService:
                return i18n.t('common.userActions.actionScope.shippingRateService').toString();
            case UserActionScopeType.PaymentOptions:
                return i18n.t('common.userActions.actionScope.paymentOptions').toString();
            case UserActionScopeType.PaymentAtLocation:
                return i18n.t('common.userActions.actionScope.paymentAtLocation').toString();
            case UserActionScopeType.PaymentOnDelivery:
                return i18n.t('common.userActions.actionScope.paymentOnDelivery').toString();
            case UserActionScopeType.BankTransferPayment:
                return i18n.t('common.userActions.actionScope.bankTransferPayment').toString();
            case UserActionScopeType.PayPalPayment:
                return i18n.t('common.userActions.actionScope.payPalPayment').toString();
            case UserActionScopeType.RedsysPayment:
                return i18n.t('common.userActions.actionScope.redsysPayment').toString();
            case UserActionScopeType.PersonalBizumPayment:
                return i18n.t('common.userActions.actionScope.personalBizumPayment').toString();
            case UserActionScopeType.NameAndDescription:
                return i18n.t('common.userActions.actionScope.nameAndDescription').toString();
            case UserActionScopeType.IsNonPhysical:
                return i18n.t('common.userActions.actionScope.isNonPhysical').toString();
            case UserActionScopeType.CategoriesAndCharacteristics:
                return i18n.t('common.userActions.actionScope.categoriesAndCharacteristics').toString();
            case UserActionScopeType.Sku:
                return i18n.t('common.userActions.actionScope.sku').toString();
            case UserActionScopeType.Skus:
                return i18n.t('common.userActions.actionScope.skus').toString();
            case UserActionScopeType.Stock:
                return i18n.t('common.userActions.actionScope.stock').toString();
            case UserActionScopeType.Discounts:
                return i18n.t('common.userActions.actionScope.discounts').toString();
            case UserActionScopeType.Resend:
                return i18n.t('common.userActions.actionScope.resend').toString();
            case UserActionScopeType.OpeningHours:
                return i18n.t('common.userActions.actionScope.openingHours').toString();
            case UserActionScopeType.OrderingHours:
                return i18n.t('common.userActions.actionScope.orderingHours').toString();
            case UserActionScopeType.ReferencesClassification:
                return i18n.t('common.userActions.actionScope.referencesClassification').toString();
            case UserActionScopeType.BusinessReferenceCategories:
                return i18n.t('common.userActions.actionScope.businessReferenceCategories').toString();
            case UserActionScopeType.BusinessReferenceCharacteristics:
                return i18n.t('common.userActions.actionScope.businessReferenceCharacteristics').toString();
            case UserActionScopeType.BusinessReferenceSkuAttributes:
                return i18n.t('common.userActions.actionScope.businessReferenceAttributes').toString();
            case UserActionScopeType.TimeSensitivity:
                return i18n.t('common.userActions.actionScope.timeSensitivity').toString();
            case UserActionScopeType.CustomHighlights:
                return i18n.t('common.userActions.actionScope.customHighlights').toString();
            case UserActionScopeType.HelpSite:
                return i18n.t('common.userActions.actionScope.helpSite').toString();
            case UserActionScopeType.ContactSettings:
                return i18n.t('common.userActions.actionScope.contactSettings').toString();
            case UserActionScopeType.SlugAvailability:
                return i18n.t('common.userActions.actionScope.slugAvailability').toString();
            case UserActionScopeType.CanonicalConsumer:
                return i18n.t('common.userActions.actionScope.canonicalConsumer').toString();
            case UserActionScopeType.Clone:
                return i18n.t('common.userActions.actionScope.clone').toString();
            case UserActionScopeType.BookingOptions:
                return i18n.t('common.userActions.actionScope.bookingOptions').toString();
            case UserActionScopeType.PlainPost:
                return i18n.t('common.userActions.actionScope.plainPost').toString();
            case UserActionScopeType.FlashOffer:
                return i18n.t('common.userActions.actionScope.flashOffer').toString();
            case UserActionScopeType.Event:
                return i18n.t('common.userActions.actionScope.event').toString();
            case UserActionScopeType.UpdatePost:
                return i18n.t('common.userActions.actionScope.updatePost').toString();
            default:
                return '-';
        }
    }

    private getUserActionEntityType(): string {
        switch (this.entity) {
            case UserActionEntityType.Associations:
                return i18n.t('common.userActions.entity.associations').toString();
            case UserActionEntityType.Businesses:
                return i18n.t('common.userActions.entity.businesses').toString();
            case UserActionEntityType.Products:
                return i18n.t('common.userActions.entity.products').toString();
            case UserActionEntityType.BusinessOrders:
                return i18n.t('common.userActions.entity.businessOrders').toString();
            case UserActionEntityType.BusinessProspects:
                return i18n.t('common.userActions.entity.businessProspects').toString();
            case UserActionEntityType.BusinessKpis:
                return i18n.t('common.userActions.entity.businessKpis').toString();
            case UserActionEntityType.UserInvitations:
                return i18n.t('common.userActions.entity.userInvitations').toString();
            case UserActionEntityType.UserActionLogs:
                return i18n.t('common.userActions.entity.userActionLogs').toString();
            case UserActionEntityType.Services:
                return i18n.t('common.userActions.entity.services').toString();
            case UserActionEntityType.BusinessBookingRequests:
                return i18n.t('common.userActions.entity.businessBookingRequests').toString();
            case UserActionEntityType.Users:
                return i18n.t('common.userActions.entity.users').toString();
            case UserActionEntityType.BusinessContacts:
                return i18n.t('common.userActions.entity.businessContacts').toString();
            case UserActionEntityType.SkuSerials:
                return i18n.t('common.userActions.entity.vouchers').toString();
            case UserActionEntityType.CampaignTracking:
                return i18n.t('common.userActions.entity.campaignTracking').toString();
            case UserActionEntityType.Posts:
                return i18n.t('common.userActions.entity.posts').toString();
            case UserActionEntityType.PlainPosts:
                return i18n.t('common.userActions.entity.plainPosts').toString();
            case UserActionEntityType.FlashOffers:
                return i18n.t('common.userActions.entity.flashOffers').toString();
            case UserActionEntityType.Events:
                return i18n.t('common.userActions.entity.events').toString();
            case UserActionEntityType.UpdatePosts:
                return i18n.t('common.userActions.entity.updatePosts').toString();
            case UserActionEntityType.FlashOffersBookingRequests:
                return i18n.t('common.userActions.entity.flashOffersBookingRequests').toString();
            default:
                return '-';
        }
    }
}
